import axios from 'axios';

// Get the API URL from environment variables
const API_URL = process.env.REACT_APP_API_URL || 'https://ecofusion-backend.vercel.app';

// Function to test CORS configuration
export const testCors = async () => {
    try {
        console.log('Running CORS test...');
        console.log('API URL:', API_URL);

        // Test basic CORS with GET request
        const response = await axios.get(`${API_URL}/api/cors-test`, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: false
        });

        console.log('CORS Test succeeded!', response.data);
        return {
            success: true,
            message: 'CORS test successful',
            data: response.data
        };
    } catch (error) {
        console.error('CORS Test failed:', error);

        let errorMessage = 'Unknown error';
        if (error.message) {
            errorMessage = error.message;
        }

        if (error.response) {
            console.error('Response status:', error.response.status);
            console.error('Response data:', error.response.data);
        }

        return {
            success: false,
            message: `CORS test failed: ${errorMessage}`,
            error
        };
    }
};

// Function to test uploading an image
export const testImageUpload = async (file) => {
    try {
        console.log('Testing image upload...');

        if (!file) {
            return {
                success: false,
                message: 'No file provided for testing'
            };
        }

        const formData = new FormData();
        formData.append('image', file);

        // Use longer timeout
        const response = await axios.post(`${API_URL}/api/soil`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            timeout: 180000,
            withCredentials: false,
            onUploadProgress: (progressEvent) => {
                console.log(`Upload progress: ${Math.round((progressEvent.loaded * 100) / progressEvent.total)}%`);
            }
        });

        console.log('Image upload test succeeded!', response.data);
        return {
            success: true,
            message: 'Image upload test successful',
            data: response.data
        };
    } catch (error) {
        console.error('Image upload test failed:', error);

        let errorMessage = 'Unknown error';
        if (error.message) {
            errorMessage = error.message;
        }

        if (error.response) {
            console.error('Response status:', error.response.status);
            console.error('Response data:', error.response.data);
        }

        return {
            success: false,
            message: `Image upload test failed: ${errorMessage}`,
            error
        };
    }
}; 